import { fromJS } from 'immutable';
import { set } from 'lodash';

import * as actions from './actions';

const initialState = fromJS({});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_REDUX_STATE.INTENT: {
      if (action.payload.key) {
        const globalKeys = action.payload.globalKeys.join('.');
        const data = set({}, `${globalKeys}.${action.payload.key}`, action.payload.value);
        // TODO need a better solution to do deepMerge where the leaf value is replaced
        const tmpState = state.mergeDeep(set({}, `${globalKeys}.${action.payload.key}`, undefined));
        return tmpState.mergeDeep(data);
      }
      return state;
    }

    case actions.UNSET_REDUX_STATE.INTENT: {
      if (action.payload.key) {
        return state.deleteIn([action.payload.globalKeys, action.payload.key]);
      }
      return state;
    }

    default:
      return state;
  }
}
